import { render, staticRenderFns } from "./GridLayoutPlaceholder.vue?vue&type=template&id=6c007777&scoped=true"
import script from "./GridLayoutPlaceholder.vue?vue&type=script&lang=js"
export * from "./GridLayoutPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./GridLayoutPlaceholder.vue?vue&type=style&index=0&id=6c007777&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c007777",
  null
  
)

export default component.exports